import {
    FETCH_RESERVATIONS,
    FETCH_RESERVATIONS_FAILURE,
    FETCH_RESERVATIONS_SUCCESS,

    FETCH_RESERVATION,
    FETCH_RESERVATION_FAILURE,
    FETCH_RESERVATION_SUCCESS,

    RESERVATIONS_LIST_FILTER_UPDATE,
    RESERVATIONS_LIST_FILTER_CATEGORY,
    RESERVATIONS_LIST_PAGE,
    RESERVATIONS_LIST_SORT,

    SORT_DESC,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'id',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_DESC,
    page: 1,
    size: 12,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_RESERVATION:
        case FETCH_RESERVATIONS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_RESERVATION_FAILURE:
        case FETCH_RESERVATIONS_FAILURE:
            return Object.assign({}, state, {
                data: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });

        case FETCH_RESERVATION_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, { [action.response.id]: action.response }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
            });

        case FETCH_RESERVATIONS_SUCCESS:

            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case RESERVATIONS_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case RESERVATIONS_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case RESERVATIONS_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case RESERVATIONS_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/reservationsReducer.js